var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("면접 일정표")]), _c('expo-matching-table', _vm._b({
    attrs: {
      "mode": "view"
    }
  }, 'expo-matching-table', {
    program: _vm.program,
    matchings: _vm.matchings,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }